/**
 * Balibay — collapse the Kite free-gift accordion AFTER the cart re-renders
 * ------------------------------------------------------------------------
 * Flow to fix: customer clicks a gift button ("Hinzufügen" / "Entfernen") →
 * the cart drawer re-renders → Kite draws the gift accordion OPEN again. We
 * want it CLOSED, but only AFTER that re-render.
 *
 * After a gift button click we arm; when the RE-RENDERED widget appears we
 * collapse it (a short retry burst beats Kite applying its open state a beat
 * later) and disarm immediately (one-shot).
 *
 * IMPORTANT: if the customer taps the bar to open it (e.g. right after adding,
 * to change the gift), we cancel any pending collapse so it opens on the FIRST
 * click. Default behaviour is otherwise completely untouched.
 *
 * Kite marks "open" via `gfgFGv2-expanded` on .gfgFGv2-dropdown-content
 * (and `gfgFGv2-chevron-open` on the arrow).
 */
(function () {
  var armedUntil = 0;
  var timers = [];

  function clearTimers() {
    timers.forEach(clearTimeout);
    timers = [];
  }

  function collapseNow() {
    document.querySelectorAll('.gfgFGv2-dropdown-content.gfgFGv2-expanded').forEach(function (el) {
      el.classList.remove('gfgFGv2-expanded');
      var scope = el.closest('.gfgFGv2-multi-widget') || el.parentElement;
      var chev = scope && scope.querySelector('.gfgFGv2-chevron-open');
      if (chev) chev.classList.remove('gfgFGv2-chevron-open');
    });
  }

  // Collapse repeatedly for a short burst so we win against Kite applying the
  // open state slightly after the widget node is inserted.
  function collapseBurst() {
    clearTimers();
    [0, 120, 300, 600, 900].forEach(function (ms) {
      timers.push(setTimeout(collapseNow, ms));
    });
  }

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      // Customer is toggling the accordion manually → stop any pending
      // auto-collapse so it opens on the first click.
      if (t.closest('.gfgFGv2-dropdown-bar')) {
        armedUntil = 0;
        clearTimers();
        return;
      }

      // Gift Add / claim / Unclaim button → arm for the upcoming re-render.
      if (t.closest('.gfgFGv2-btn')) {
        armedUntil = Date.now() + 6000;
      }
    },
    true
  );

  // When the gift widget is (re)rendered while armed, collapse it once.
  try {
    new MutationObserver(function (mutations) {
      if (Date.now() > armedUntil) return;
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (
            (n.matches && n.matches('.gfgFGv2-dropdown-content, .gfgFGv2-multi-widget, [class*="gfgFGv2-widget"]')) ||
            (n.querySelector && n.querySelector('.gfgFGv2-dropdown-content'))
          ) {
            armedUntil = 0; // one-shot
            collapseBurst();
            return;
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();